/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type StartMissionInput = {
  missionId: string,
};

export type Mission = {
  __typename?: "Mission",
  actualArrivalTime?: string | null,
  actualStartTime?: string | null,
  createdAt: string,
  description?: string | null,
  events?:  Array<MissionEvent > | null,
  fleetId?: string | null,
  id: string,
  name: string,
  plannedArrivalTime?: string | null,
  progressDetails?: MissionProgressDetails | null,
  route?: GeneratedRoute | null,
  state: MissionState,
  updatedAt: string,
  vin: string,
};

export type MissionEvent = {
  __typename?: "MissionEvent",
  createdAt: string,
  position: Position,
  type: MissionEventType,
};

export type Position = {
  __typename?: "Position",
  altitude?: number | null,
  heading?: number | null,
  latitude?: number | null,
  longitude?: number | null,
};

export enum MissionEventType {
  MISSION_ARCHIVED = "MISSION_ARCHIVED",
  MISSION_CANCELED = "MISSION_CANCELED",
  MISSION_COMPLETE = "MISSION_COMPLETE",
  MISSION_EXECUTING = "MISSION_EXECUTING",
  MISSION_LANDED = "MISSION_LANDED",
  MISSION_PAUSED_BY_MRM = "MISSION_PAUSED_BY_MRM",
  MISSION_PAUSING_FOR_MRM = "MISSION_PAUSING_FOR_MRM",
  MISSION_READY_TO_LAUNCH = "MISSION_READY_TO_LAUNCH",
  MISSION_READY_TO_RESUME = "MISSION_READY_TO_RESUME",
  MISSION_RESET = "MISSION_RESET",
  MISSION_RESUMED = "MISSION_RESUMED",
  MISSION_ASSIGNED = "MISSION_ASSIGNED",
  MISSION_COMPLETED = "MISSION_COMPLETED",
  MISSION_STARTED = "MISSION_STARTED",
}


export type MissionProgressDetails = {
  __typename?: "MissionProgressDetails",
  eta: string,
  remainingDistanceInMeters: number,
  traveledDistanceInMeters: number,
  updatedAt: string,
};

export type GeneratedRoute = {
  __typename?: "GeneratedRoute",
  createdAt: string,
  durationInSeconds: number,
  externalRouteId: string,
  landingHub: Hub,
  launchHub: Hub,
  predefinedRouteId: string,
  totalDistanceInMeters: number,
  updatedAt: string,
  waypoints:  Array<Position >,
};

export type Hub = {
  __typename?: "Hub",
  active: boolean,
  address?: string | null,
  createdAt: string,
  id: string,
  name: string,
  position: Coordinate,
  updatedAt: string,
};

export type Coordinate = {
  __typename?: "Coordinate",
  latitude?: number | null,
  longitude?: number | null,
};

export type MissionState = {
  __typename?: "MissionState",
  updatedAt: string,
  value: MissionStateValue,
};

export enum MissionStateValue {
  CANCELED = "CANCELED",
  COMPLETE = "COMPLETE",
  EXECUTING = "EXECUTING",
  FAILED = "FAILED",
  LANDED = "LANDED",
  PAUSED = "PAUSED",
  PAUSING = "PAUSING",
  READY_TO_LAUNCH = "READY_TO_LAUNCH",
  READY_TO_RESUME = "READY_TO_RESUME",
  RESET = "RESET",
  SCHEDULED = "SCHEDULED",
  UNKNOWN = "UNKNOWN",
  ASSIGNED = "ASSIGNED",
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
}


export type ArchiveMissionInput = {
  missionId: string,
};

export type AssignMissionInput = {
  predefinedRouteId: string,
  vin: string,
};

export type CancelMissionInput = {
  missionId: string,
};

export type ContinueStreamInput = {
  cameraID?: string | null,
  vin: string,
};

export type ContinueVideoStream = {
  __typename?: "ContinueVideoStream",
  cameraID?: string | null,
  vin: string,
};

export type CreateHubInput = {
  active: boolean,
  name: string,
  position: CoordinateInput,
  address: string,
};

export type CoordinateInput = {
  latitude?: number | null,
  longitude?: number | null,
};

export type CreateUserInput = {
  firstName: string,
  lastName: string,
  email: string,
  phone?: string | null,
  city?: string | null,
  country?: string | null,
  roles: Array< string >,
  teams?: Array< string > | null,
};

export type User = {
  __typename?: "User",
  city?: string | null,
  country?: string | null,
  createdAt: string,
  updatedAt: string,
  email: string,
  firstName: string,
  id: string,
  lastName: string,
  phone?: string | null,
  roles:  Array<SystemRole >,
  status: Status,
  teams?:  Array<UserTeam > | null,
};

export type SystemRole = {
  __typename?: "SystemRole",
  id: string,
  name: string,
  createdAt: string,
  updatedAt: string,
  claims:  Array<RoleClaim >,
  useWildcardClaims: boolean,
};

export type RoleClaim = {
  __typename?: "RoleClaim",
  pattern: string,
  createdAt: string,
  updatedAt: string,
};

export enum Status {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  INVITED = "INVITED",
}


export type UserTeam = {
  __typename?: "UserTeam",
  id: string,
  name: string,
};

export type DeleteVehicleDeviationsInput = {
  vin: string,
};

export type Vehicle = {
  __typename?: "Vehicle",
  activeMissionId?: string | null,
  adsState: AdsState,
  cameras:  Array<Camera >,
  connectivityStatus?: ConnectivityStatus | null,
  createdAt: string,
  customerId?: string | null,
  deviations:  Array<Deviation >,
  drivingState: DrivingState,
  externalId: string,
  fleetId?: string | null,
  latestVehicleUpdate?: string | null,
  licensePlate?: string | null,
  mrmState: MRMState,
  name?: string | null,
  owners:  Array<Owner >,
  position?: Position | null,
  driverMode?: DriverMode | null,
  speedInKmh?: number | null,
  speedInMs?: number | null,
  updatedAt: string,
  vin: string,
  weightInKg?: number | null,
};

export enum AdsState {
  AUTONOMOUS = "AUTONOMOUS",
  NOT_AVAILABLE = "NOT_AVAILABLE",
  SHADOW = "SHADOW",
  UNKNOWN = "UNKNOWN",
}


export type Camera = {
  __typename?: "Camera",
  id?: string | null,
  name: string,
};

export type ConnectivityStatus = {
  __typename?: "ConnectivityStatus",
  description?: string | null,
  expectedDisconnect?: boolean | null,
  latency?: number | null,
  reason?: Reason | null,
  state?: ConnectivityState | null,
};

export enum Reason {
  EXPECTED = "EXPECTED",
  UNEXPECTED = "UNEXPECTED",
  UNKNOWN = "UNKNOWN",
}


export enum ConnectivityState {
  OFFLINE = "OFFLINE",
  ONLINE = "ONLINE",
  UNKNOWN = "UNKNOWN",
}


export type Deviation = {
  __typename?: "Deviation",
  category: string,
  description: string,
  id: string,
  isBlocking: boolean,
  origin: string,
  sentAt: string,
  severity: Severity,
  relatedDeviations: Array< string | null >,
  resolvedAt?: string | null,
  state?: DeviationState | null,
};

export enum Severity {
  ERROR = "ERROR",
  WARNING = "WARNING",
  UNKNOWN = "UNKNOWN",
  FATAL = "FATAL",
  INFO = "INFO",
  INVALID = "INVALID",
}


export enum DeviationState {
  RESOLVED = "RESOLVED",
  ACTIVE = "ACTIVE",
  UNKNOWN = "UNKNOWN",
}


export enum DrivingState {
  DRIVING = "DRIVING",
  IDLE = "IDLE",
  PARKED = "PARKED",
  REVERSING = "REVERSING",
  UNKNOWN = "UNKNOWN",
}


export type MRMState = {
  __typename?: "MRMState",
  updatedAt: string,
  startedAt?: string | null,
  value: MRMStateValue,
  triggerBy?: MrmTriggerValue | null,
  mrmExecutionPhase?: MrmExecutionPhase | null,
  mrmType?: MrmType | null,
  causes?:  Array<DeviationCause > | null,
  error?: Error | null,
};

export enum MRMStateValue {
  EXECUTING_MRM = "EXECUTING_MRM",
  MRC = "MRC",
  NONE = "NONE",
  RELEASING_MRC = "RELEASING_MRC",
  MRM_FAULTED = "MRM_FAULTED",
  ERROR = "ERROR",
}


export enum MrmTriggerValue {
  MRM_TRIGGER_VALUE_OFFBOARD = "MRM_TRIGGER_VALUE_OFFBOARD",
  MRM_TRIGGER_VALUE_ONBOARD = "MRM_TRIGGER_VALUE_ONBOARD",
}


export enum MrmExecutionPhase {
  MRM_EXECUTION_PHASE_UNSPECIFIED = "MRM_EXECUTION_PHASE_UNSPECIFIED",
  MRM_EXECUTION_PHASE_PRE_DECELERATION = "MRM_EXECUTION_PHASE_PRE_DECELERATION",
  MRM_EXECUTION_PHASE_WAIT_FOR_SHOULDER = "MRM_EXECUTION_PHASE_WAIT_FOR_SHOULDER",
  MRM_EXECUTION_PHASE_SLOWDOWN_FOR_POTS = "MRM_EXECUTION_PHASE_SLOWDOWN_FOR_POTS",
  MRM_EXECUTION_PHASE_PULL_TO_SHOULDER = "MRM_EXECUTION_PHASE_PULL_TO_SHOULDER",
  MRM_EXECUTION_PHASE_STOP_IN_LANE = "MRM_EXECUTION_PHASE_STOP_IN_LANE",
  MRM_EXECUTION_PHASE_NOT_AVAILABLE = "MRM_EXECUTION_PHASE_NOT_AVAILABLE",
  MRM_EXECUTION_PHASE_ERROR = "MRM_EXECUTION_PHASE_ERROR",
  MRM_EXECUTION_PHASE_UNKNOWN = "MRM_EXECUTION_PHASE_UNKNOWN",
}


export enum MrmType {
  UNKNOWN = "UNKNOWN",
  SHOULDER_STOP = "SHOULDER_STOP",
  LANE_STOP = "LANE_STOP",
  ERROR = "ERROR",
  NOT_AVAILABLE = "NOT_AVAILABLE",
}


export type DeviationCause = {
  __typename?: "DeviationCause",
  deviationId: string,
};

export enum Error {
  ERROR_UNSPECIFIED = "ERROR_UNSPECIFIED",
  ERROR_UNKNOWN = "ERROR_UNKNOWN",
  ERROR_UNAVAILABLE = "ERROR_UNAVAILABLE",
  ERROR_TIMEOUT = "ERROR_TIMEOUT",
}


export type Owner = {
  __typename?: "Owner",
  email: string,
  fullName: string,
  id: string,
  phoneNumber: string,
  position: string,
};

export enum DriverMode {
  DRIVER_MODE_IN_SUPERVISED = "DRIVER_MODE_IN_SUPERVISED",
  DRIVER_MODE_OUT_AUTOMATED = "DRIVER_MODE_OUT_AUTOMATED",
  DRIVER_MODE_UNKNOWN = "DRIVER_MODE_UNKNOWN",
}


export type ResetMissionInput = {
  missionId: string,
};

export type VehicleCommandInput = {
  command: Command,
  vin: string,
};

export enum Command {
  MRM = "MRM",
  RELEASE = "RELEASE",
  START_MISSION = "START_MISSION",
}


export type CommandResponse = {
  __typename?: "CommandResponse",
  command: Command,
  errorMessage?: string | null,
  invocationId: string,
  isSuccess: boolean,
  receivedByVehicleAt: string,
  sentToVehicleAt: string,
  vin: string,
};

export type UpdateHubInput = {
  id: string,
  name: string,
  position: CoordinateInput,
  active: boolean,
  address: string,
};

export type UpdatedMissionInput = {
  actualArrivalTime?: string | null,
  actualStartTime?: string | null,
  createdAt: string,
  description?: string | null,
  events?: Array< MissionEventInput > | null,
  fleetId?: string | null,
  id: string,
  name: string,
  plannedArrivalTime?: string | null,
  progressDetails?: MissionProgressDetailsInput | null,
  route?: UpdatedGeneratedRouteInput | null,
  state: MissionStateInput,
  updatedAt: string,
  vin: string,
};

export type MissionEventInput = {
  createdAt: string,
  position: PositionInput,
  type: MissionEventType,
};

export type PositionInput = {
  altitude?: number | null,
  heading?: number | null,
  latitude?: number | null,
  longitude?: number | null,
};

export type MissionProgressDetailsInput = {
  eta: string,
  remainingDistanceInMeters: number,
  traveledDistanceInMeters: number,
  updatedAt: string,
};

export type UpdatedGeneratedRouteInput = {
  createdAt: string,
  durationInSeconds: number,
  externalRouteId: string,
  launchHub: HubInput,
  landingHub: HubInput,
  predefinedRouteId: string,
  totalDistanceInMeters: number,
  updatedAt: string,
  waypoints: Array< PositionInput >,
};

export type HubInput = {
  id: string,
  name: string,
  position: CoordinateInput,
  active: boolean,
  address?: string | null,
  createdAt: string,
  updatedAt: string,
};

export type MissionStateInput = {
  updatedAt: string,
  value: MissionStateValue,
};

export type UpdatedVehicleInput = {
  activeMissionId?: string | null,
  adsState: AdsState,
  cameras: Array< CameraInput >,
  connectivityStatus?: ConnectivityStatusInput | null,
  createdAt: string,
  customerId?: string | null,
  deviations: Array< DeviationInput >,
  drivingState: DrivingState,
  externalId: string,
  fleetId?: string | null,
  latestVehicleUpdate?: string | null,
  licensePlate?: string | null,
  mrmState: MRMStateInput,
  name?: string | null,
  owners: Array< OwnerInput >,
  position?: PositionInput | null,
  speedInKmh?: number | null,
  driverMode?: DriverMode | null,
  speedInMs?: number | null,
  updatedAt: string,
  vin: string,
  weightInKg?: number | null,
};

export type CameraInput = {
  id?: string | null,
  name: string,
};

export type ConnectivityStatusInput = {
  description?: string | null,
  expectedDisconnect?: boolean | null,
  latency?: number | null,
  reason?: Reason | null,
  state?: ConnectivityState | null,
};

export type DeviationInput = {
  category: string,
  description: string,
  id: string,
  isBlocking: boolean,
  origin: string,
  sentAt: string,
  severity: Severity,
  relatedDeviations: Array< string | null >,
  resolvedAt?: string | null,
  state?: DeviationState | null,
};

export type MRMStateInput = {
  updatedAt: string,
  startedAt?: string | null,
  value: MRMStateValue,
  triggerBy?: MrmTriggerValue | null,
  mrmExecutionPhase?: MrmExecutionPhase | null,
  mrmType?: MrmType | null,
  causes?: Array< DeviationCauseInput > | null,
  error?: Error | null,
};

export type DeviationCauseInput = {
  deviationId: string,
};

export type OwnerInput = {
  email: string,
  fullName: string,
  id: string,
  phoneNumber: string,
  position: string,
};

export type UpdatedVehicleByVinInput = {
  activeMissionId?: string | null,
  adsState: AdsState,
  cameras: Array< CameraInput >,
  connectivityStatus?: ConnectivityStatusInput | null,
  createdAt: string,
  customerId?: string | null,
  deviations: Array< DeviationInput >,
  drivingState: DrivingState,
  externalId: string,
  fleetId?: string | null,
  latestVehicleUpdate?: string | null,
  licensePlate?: string | null,
  mrmState: MRMStateInput,
  name?: string | null,
  owners: Array< OwnerInput >,
  position?: PositionInput | null,
  speedInKmh?: number | null,
  driverMode?: DriverMode | null,
  speedInMs?: number | null,
  updatedAt: string,
  vin: string,
  weightInKg?: number | null,
};

export type UpdatedVideoStreamingErrorInput = {
  cameraID?: string | null,
  errorCode: VideoStreamingErrorCode,
  errorMessage?: string | null,
  vin: string,
};

export enum VideoStreamingErrorCode {
  CAMERA_DOES_NOT_EXIST = "CAMERA_DOES_NOT_EXIST",
  STREAM_NOT_RUNNING = "STREAM_NOT_RUNNING",
  UNEXPECTED_END_OF_STREAM = "UNEXPECTED_END_OF_STREAM",
  UNKNOWN_STREAM_ERROR = "UNKNOWN_STREAM_ERROR",
}


export type VideoStreamingError = {
  __typename?: "VideoStreamingError",
  cameraID?: string | null,
  errorCode: VideoStreamingErrorCode,
  errorMessage?: string | null,
  vin: string,
};

export type UpdatedFleetInput = {
  id: string,
  name: string,
  teams: Array< string >,
  vehicles: Array< string >,
};

export type SystemFleet = {
  __typename?: "SystemFleet",
  id: string,
  name: string,
  createdAt: string,
  updatedAt: string,
  teams?:  Array<TeamInfo > | null,
  numberOfVehicles: number,
};

export type TeamInfo = {
  __typename?: "TeamInfo",
  id: string,
  name: string,
};

export type UpdatedUserInput = {
  id: string,
  firstName: string,
  lastName: string,
  phone: string,
  country: string,
  city: string,
  teams: Array< string | null >,
  roles: Array< string | null >,
};

export type ResetPasswordResult = ResetPasswordSuccessful | UserNotActiveError | ValidationError | SystemError | NotFoundError


export type ResetPasswordSuccessful = {
  __typename?: "ResetPasswordSuccessful",
  statusCode: number,
};

export type UserNotActiveError = {
  __typename?: "UserNotActiveError",
  statusCode: number,
  errorCode: string,
};

export type ValidationError = {
  __typename?: "ValidationError",
  statusCode: number,
  errorCode: string,
};

export type SystemError = {
  __typename?: "SystemError",
  statusCode: number,
  errorCode: string,
};

export type NotFoundError = {
  __typename?: "NotFoundError",
  statusCode: number,
  errorCode: string,
};

export type DeleteUserResult = DeleteUserSuccessful | SelfDeleteError | ValidationError | SystemError | NotFoundError


export type DeleteUserSuccessful = {
  __typename?: "DeleteUserSuccessful",
  statusCode: number,
};

export type SelfDeleteError = {
  __typename?: "SelfDeleteError",
  statusCode: number,
  errorCode: string,
};

export type CreateFleetInput = {
  name: string,
  teams: Array< string | null >,
  vehicles: Array< string | null >,
};

export type CreateTeamInput = {
  name: string,
  fleets?: Array< string > | null,
  users?: Array< string > | null,
};

export type Team = {
  __typename?: "Team",
  id: string,
  name: string,
  users?: Array< string > | null,
  fleets?: Array< string > | null,
  createdAt: string,
  updatedAt: string,
};

export type UpdateTeamInput = {
  id: string,
  name: string,
  fleets?: Array< string > | null,
  users?: Array< string > | null,
};

export type UpdatedMissionInputV2 = {
  id: string,
  vin: string,
  timestamp: string,
  events?: Array< MissionEventInput | null > | null,
  version: string,
  actualArrivalTime?: string | null,
  actualStartTime?: string | null,
  description?: string | null,
  fleetId?: string | null,
  name?: string | null,
  plannedArrivalTime?: string | null,
  progressDetails?: MissionProgressDetailsFieldInputV2 | null,
  route?: GeneratedRouteInputV2 | null,
  state?: MissionStateFieldInputV2 | null,
};

export type MissionProgressDetailsFieldInputV2 = {
  ttl?: number | null,
  value?: MissionProgressDetailsValueInputV2 | null,
  error?: ErrorInputV2 | null,
};

export type MissionProgressDetailsValueInputV2 = {
  eta: string,
  remainingDistanceInMeters: number,
  traveledDistanceInMeters: number,
  updatedAt: string,
};

export type ErrorInputV2 = {
  type: ErrorTypeV2,
  raisedAt: string,
};

export enum ErrorTypeV2 {
  UNSPECIFIED = "UNSPECIFIED",
  UNKNOWN = "UNKNOWN",
  UNAVAILABLE = "UNAVAILABLE",
  TIMEOUT = "TIMEOUT",
  NOT_CONFIGURED = "NOT_CONFIGURED",
  PARSING_ERROR = "PARSING_ERROR",
}


export type GeneratedRouteInputV2 = {
  createdAt: string,
  durationInSeconds: number,
  externalRouteId: string,
  landingHub: HubInput,
  launchHub: HubInput,
  predefinedRouteId: string,
  totalDistanceInMeters: number,
  updatedAt: string,
  positions: Array< PositionInput >,
};

export type MissionStateFieldInputV2 = {
  ttl?: number | null,
  value?: MissionStateValueInputV2 | null,
  error?: ErrorInputV2 | null,
};

export type MissionStateValueInputV2 = {
  state: MissionStateValue,
  updatedAt: string,
};

export type MissionV2 = {
  __typename?: "MissionV2",
  id: string,
  vin: string,
  timestamp: string,
  version: string,
  actualArrivalTime?: string | null,
  actualStartTime?: string | null,
  description?: string | null,
  events?:  Array<MissionEvent > | null,
  fleetId: string,
  name: string,
  plannedArrivalTime?: string | null,
  progressDetails?: MissionProgressDetailsFieldV2 | null,
  route?: GeneratedRouteV2 | null,
  state?: MissionStateFieldV2 | null,
};

export type MissionProgressDetailsFieldV2 = {
  __typename?: "MissionProgressDetailsFieldV2",
  ttl?: number | null,
  value?: MissionProgressDetailsValueV2 | null,
  error?: ErrorV2 | null,
};

export type MissionProgressDetailsValueV2 = {
  __typename?: "MissionProgressDetailsValueV2",
  eta: string,
  remainingDistanceInMeters: number,
  traveledDistanceInMeters: number,
  updatedAt: string,
};

export type ErrorV2 = {
  __typename?: "ErrorV2",
  type: ErrorTypeV2,
  raisedAt: string,
};

export type GeneratedRouteV2 = {
  __typename?: "GeneratedRouteV2",
  createdAt: string,
  durationInSeconds: number,
  externalRouteId: string,
  landingHub: Hub,
  launchHub: Hub,
  predefinedRouteId: string,
  totalDistanceInMeters: number,
  updatedAt: string,
  positions:  Array<Position >,
};

export type MissionStateFieldV2 = {
  __typename?: "MissionStateFieldV2",
  ttl?: number | null,
  value?: MissionStateValueV2 | null,
  error?: ErrorV2 | null,
};

export type MissionStateValueV2 = {
  __typename?: "MissionStateValueV2",
  state: MissionStateValue,
  updatedAt: string,
};

export type UpdatedVehicleInputV2 = {
  vin: string,
  timestamp: string,
  owners: Array< OwnerInput >,
  fleetId?: string | null,
  licensePlate?: string | null,
  latestVehicleUpdate?: string | null,
  activeMissionId?: StringFieldInputV2 | null,
  adsState?: AdsStateFieldInputV2 | null,
  connectivityStatus?: ConnectivityStatusFieldInputV2 | null,
  deviations: Array< DeviationsFieldInputV2 | null >,
  driverMode?: DriverModeFieldInputV2 | null,
  drivingState?: DrivingStateFieldInputV2 | null,
  mrmState?: MrmStateFieldInputV2 | null,
  position?: PositionFieldInputV2 | null,
  speedMs?: SpeedMsFieldInputV2 | null,
  name?: string | null,
};

export type StringFieldInputV2 = {
  ttl?: number | null,
  value?: StringValueInputV2 | null,
  error?: ErrorInputV2 | null,
};

export type StringValueInputV2 = {
  data: string,
  updatedAt: string,
};

export type AdsStateFieldInputV2 = {
  ttl?: number | null,
  value?: AdsStateValueInputV2 | null,
  error?: ErrorInputV2 | null,
};

export type AdsStateValueInputV2 = {
  state: AdsState,
  updatedAt: string,
};

export type ConnectivityStatusFieldInputV2 = {
  ttl?: number | null,
  value?: ConnectivityStatusValueInputV2 | null,
  error?: ErrorInputV2 | null,
};

export type ConnectivityStatusValueInputV2 = {
  expectDisconnection: boolean,
  latency?: number | null,
  state?: ConnectivityState | null,
  updatedAt: string,
};

export type DeviationsFieldInputV2 = {
  ttl?: number | null,
  value?: DeviationValueInputV2 | null,
  error?: ErrorInputV2 | null,
};

export type DeviationValueInputV2 = {
  deviation: DeviationInput,
  updatedAt: string,
};

export type DriverModeFieldInputV2 = {
  ttl?: number | null,
  value?: DriverModeValueInputV2 | null,
  error?: ErrorInputV2 | null,
};

export type DriverModeValueInputV2 = {
  mode: DriverMode,
  updatedAt: string,
};

export type DrivingStateFieldInputV2 = {
  ttl?: number | null,
  value?: DrivingStateValueInputV2 | null,
  error?: ErrorInputV2 | null,
};

export type DrivingStateValueInputV2 = {
  state: DrivingState,
  updatedAt: string,
};

export type MrmStateFieldInputV2 = {
  ttl?: number | null,
  value?: MrmStateValueInputV2 | null,
  error?: ErrorInputV2 | null,
};

export type MrmStateValueInputV2 = {
  data: MrmStateValueDataInputV2,
  updatedAt: string,
};

export type MrmStateValueDataInputV2 = {
  value: MRMStateValue,
  executionPhase?: MrmExecutionPhase | null,
  causes?: Array< string | null > | null,
  startedAt?: string | null,
  triggerBy?: MrmTriggerValue | null,
  mrmType?: MrmType | null,
};

export type PositionFieldInputV2 = {
  ttl?: number | null,
  value?: PositionValueInputV2 | null,
  error?: ErrorInputV2 | null,
};

export type PositionValueInputV2 = {
  position: PositionInput,
  updatedAt: string,
};

export type SpeedMsFieldInputV2 = {
  ttl?: number | null,
  value?: SpeedMsValueInputV2 | null,
  error?: ErrorInputV2 | null,
};

export type SpeedMsValueInputV2 = {
  speedMs: number,
  updatedAt: string,
};

export type VehicleV2 = {
  __typename?: "VehicleV2",
  vin: string,
  timestamp: string,
  activeMissionId?: StringFieldV2 | null,
  adsState?: AdsStateFieldV2 | null,
  connectivityStatus?: ConnectivityStatusFieldV2 | null,
  deviations?:  Array<DeviationsFieldV2 | null > | null,
  driverMode?: DriverModeFieldV2 | null,
  drivingState?: DrivingStateFieldV2 | null,
  fleetId?: string | null,
  latestVehicleUpdate?: string | null,
  licensePlate?: string | null,
  mrmState?: MrmStateFieldV2 | null,
  name: string,
  owners:  Array<Owner >,
  position?: PositionFieldV2 | null,
  speedMs?: SpeedMsFieldV2 | null,
};

export type StringFieldV2 = {
  __typename?: "StringFieldV2",
  ttl?: number | null,
  value?: StringValueV2 | null,
  error?: ErrorV2 | null,
};

export type StringValueV2 = {
  __typename?: "StringValueV2",
  data: string,
  updatedAt: string,
};

export type AdsStateFieldV2 = {
  __typename?: "AdsStateFieldV2",
  ttl?: number | null,
  value?: AdsStateValueV2 | null,
  error?: ErrorV2 | null,
};

export type AdsStateValueV2 = {
  __typename?: "AdsStateValueV2",
  state: AdsState,
  updatedAt: string,
};

export type ConnectivityStatusFieldV2 = {
  __typename?: "ConnectivityStatusFieldV2",
  ttl?: number | null,
  value?: ConnectivityStatusValueV2 | null,
  error?: ErrorV2 | null,
};

export type ConnectivityStatusValueV2 = {
  __typename?: "ConnectivityStatusValueV2",
  expectDisconnection: boolean,
  latency?: number | null,
  state?: ConnectivityState | null,
  updatedAt: string,
};

export type DeviationsFieldV2 = {
  __typename?: "DeviationsFieldV2",
  ttl?: number | null,
  value?: DeviationsValueV2 | null,
  error?: ErrorV2 | null,
};

export type DeviationsValueV2 = {
  __typename?: "DeviationsValueV2",
  deviation: Deviation,
  updatedAt: string,
};

export type DriverModeFieldV2 = {
  __typename?: "DriverModeFieldV2",
  ttl?: number | null,
  value?: DriverModeValueV2 | null,
  error?: ErrorV2 | null,
};

export type DriverModeValueV2 = {
  __typename?: "DriverModeValueV2",
  mode: DriverMode,
  updatedAt: string,
};

export type DrivingStateFieldV2 = {
  __typename?: "DrivingStateFieldV2",
  ttl?: number | null,
  value?: DrivingStateValueV2 | null,
  error?: ErrorV2 | null,
};

export type DrivingStateValueV2 = {
  __typename?: "DrivingStateValueV2",
  state: DrivingState,
  updatedAt: string,
};

export type MrmStateFieldV2 = {
  __typename?: "MrmStateFieldV2",
  ttl?: number | null,
  value?: MrmStateValueV2 | null,
  error?: ErrorV2 | null,
};

export type MrmStateValueV2 = {
  __typename?: "MrmStateValueV2",
  data: MrmStateValueDataV2,
  updatedAt: string,
};

export type MrmStateValueDataV2 = {
  __typename?: "MrmStateValueDataV2",
  value: MRMStateValue,
  executionPhase?: MrmExecutionPhase | null,
  causes?: Array< string | null > | null,
  startedAt?: string | null,
  triggerBy?: MrmTriggerValue | null,
  mrmType?: MrmType | null,
};

export type PositionFieldV2 = {
  __typename?: "PositionFieldV2",
  ttl?: number | null,
  value?: PositionValueV2 | null,
  error?: ErrorV2 | null,
};

export type PositionValueV2 = {
  __typename?: "PositionValueV2",
  position: Position,
  updatedAt: string,
};

export type SpeedMsFieldV2 = {
  __typename?: "SpeedMsFieldV2",
  ttl?: number | null,
  value?: SpeedMsValueV2 | null,
  error?: ErrorV2 | null,
};

export type SpeedMsValueV2 = {
  __typename?: "SpeedMsValueV2",
  speedMs: number,
  updatedAt: string,
};

export type VehicleOrError = VehicleV2 | ErrorResponse


export type ErrorResponse = {
  __typename?: "ErrorResponse",
  statusCode: number,
  errorCode: string,
};

export type CreateMissionInputV2 = {
  predefinedRouteId: string,
  vin: string,
};

export type MissionOrError = MissionV2 | ErrorResponse


export type UpdatedMissionInputV3 = {
  vin: string,
  timestamp: string,
  version: string,
  missionId?: string | null,
  fleetId?: string | null,
  payload: MissionPayloadInputV3,
};

export type MissionPayloadInputV3 = {
  mission?: MissionDataInputV3 | null,
  unassigned?: MissionUnassignedInputV3 | null,
};

export type MissionDataInputV3 = {
  name?: string | null,
  description?: string | null,
  actualArrivalTime?: string | null,
  actualStartTime?: string | null,
  plannedArrivalTime?: string | null,
  events?: Array< MissionEventInput | null > | null,
  progressDetails?: MissionProgressDetailsFieldInputV2 | null,
  route?: GeneratedRouteInputV2 | null,
  state?: MissionStateFieldInputV2 | null,
};

export type MissionUnassignedInputV3 = {
  _placeholder?: boolean | null,
};

export type MissionUpdateV3 = {
  __typename?: "MissionUpdateV3",
  vin: string,
  fleetId?: string | null,
  payload: MissionOrUnassigned,
};

export type MissionOrUnassigned = MissionV2 | MissionUnassigned


export type MissionUnassigned = {
  __typename?: "MissionUnassigned",
  vin: string,
  timestamp: string,
  version: string,
  fleetId: string,
};

export type CameraImage = {
  __typename?: "CameraImage",
  timestamp: string,
  value: string,
};

export type HealthStatusInformation = {
  __typename?: "HealthStatusInformation",
  status: HealthStatus,
};

export enum HealthStatus {
  ERROR = "ERROR",
  OK = "OK",
}


export type VideoStream = {
  __typename?: "VideoStream",
  cameraID?: string | null,
  streamingURL: string,
  vin: string,
};

export type Route = {
  __typename?: "Route",
  averageDuration: number,
  createdAt: string,
  distance: number,
  id: string,
  landingHub: Hub,
  launchHub: Hub,
  updatedAt: string,
};

export type SystemTeamInfo = {
  __typename?: "SystemTeamInfo",
  id: string,
  users?:  Array<TeamUserInfo > | null,
  fleets?:  Array<TeamFleetInfo > | null,
  createdAt: string,
  updatedAt: string,
};

export type TeamUserInfo = {
  __typename?: "TeamUserInfo",
  id: string,
  firstName: string,
  lastName: string,
};

export type TeamFleetInfo = {
  __typename?: "TeamFleetInfo",
  id: string,
  name: string,
};

export type SystemTeam = {
  __typename?: "SystemTeam",
  id: string,
  name: string,
  numberOfUsers: number,
  numberOfFleets: number,
  createdAt: string,
  updatedAt: string,
};

export type SystemFleetDetail = {
  __typename?: "SystemFleetDetail",
  fleetId: string,
  vehicles?:  Array<VehicleInfo | null > | null,
};

export type VehicleInfo = {
  __typename?: "VehicleInfo",
  vin: string,
  name: string,
};

export type SystemVersion = {
  __typename?: "SystemVersion",
  version: string,
  services?:  Array<SystemVersionItem | null > | null,
};

export type SystemVersionItem = {
  __typename?: "SystemVersionItem",
  service: string,
  version: string,
};

export type GeneratedRouteOrError = GeneratedRouteV2 | ErrorResponse


export type VehicleListOrError = VehicleList | ErrorResponse


export type VehicleList = {
  __typename?: "VehicleList",
  items?:  Array<VehicleV2 | null > | null,
};

export type StartMissionMutationVariables = {
  input: StartMissionInput,
};

export type StartMissionMutation = {
  startMission?:  {
    __typename?: "Mission",
    actualArrivalTime?: string | null,
    actualStartTime?: string | null,
    createdAt: string,
    description?: string | null,
    events?:  Array< {
      __typename?: "MissionEvent",
      createdAt: string,
      position:  {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      },
      type: MissionEventType,
    } > | null,
    fleetId?: string | null,
    id: string,
    name: string,
    plannedArrivalTime?: string | null,
    progressDetails?:  {
      __typename?: "MissionProgressDetails",
      eta: string,
      remainingDistanceInMeters: number,
      traveledDistanceInMeters: number,
      updatedAt: string,
    } | null,
    route?:  {
      __typename?: "GeneratedRoute",
      createdAt: string,
      durationInSeconds: number,
      externalRouteId: string,
      landingHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      launchHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      predefinedRouteId: string,
      totalDistanceInMeters: number,
      updatedAt: string,
      waypoints:  Array< {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      } >,
    } | null,
    state:  {
      __typename?: "MissionState",
      updatedAt: string,
      value: MissionStateValue,
    },
    updatedAt: string,
    vin: string,
  } | null,
};

export type ArchiveMissionMutationVariables = {
  input: ArchiveMissionInput,
};

export type ArchiveMissionMutation = {
  archiveMission?:  {
    __typename?: "Mission",
    actualArrivalTime?: string | null,
    actualStartTime?: string | null,
    createdAt: string,
    description?: string | null,
    events?:  Array< {
      __typename?: "MissionEvent",
      createdAt: string,
      position:  {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      },
      type: MissionEventType,
    } > | null,
    fleetId?: string | null,
    id: string,
    name: string,
    plannedArrivalTime?: string | null,
    progressDetails?:  {
      __typename?: "MissionProgressDetails",
      eta: string,
      remainingDistanceInMeters: number,
      traveledDistanceInMeters: number,
      updatedAt: string,
    } | null,
    route?:  {
      __typename?: "GeneratedRoute",
      createdAt: string,
      durationInSeconds: number,
      externalRouteId: string,
      landingHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      launchHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      predefinedRouteId: string,
      totalDistanceInMeters: number,
      updatedAt: string,
      waypoints:  Array< {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      } >,
    } | null,
    state:  {
      __typename?: "MissionState",
      updatedAt: string,
      value: MissionStateValue,
    },
    updatedAt: string,
    vin: string,
  } | null,
};

export type AssignMissionMutationVariables = {
  input: AssignMissionInput,
};

export type AssignMissionMutation = {
  assignMission:  {
    __typename?: "Mission",
    actualArrivalTime?: string | null,
    actualStartTime?: string | null,
    createdAt: string,
    description?: string | null,
    events?:  Array< {
      __typename?: "MissionEvent",
      createdAt: string,
      position:  {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      },
      type: MissionEventType,
    } > | null,
    fleetId?: string | null,
    id: string,
    name: string,
    plannedArrivalTime?: string | null,
    progressDetails?:  {
      __typename?: "MissionProgressDetails",
      eta: string,
      remainingDistanceInMeters: number,
      traveledDistanceInMeters: number,
      updatedAt: string,
    } | null,
    route?:  {
      __typename?: "GeneratedRoute",
      createdAt: string,
      durationInSeconds: number,
      externalRouteId: string,
      landingHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      launchHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      predefinedRouteId: string,
      totalDistanceInMeters: number,
      updatedAt: string,
      waypoints:  Array< {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      } >,
    } | null,
    state:  {
      __typename?: "MissionState",
      updatedAt: string,
      value: MissionStateValue,
    },
    updatedAt: string,
    vin: string,
  },
};

export type CancelMissionMutationVariables = {
  input: CancelMissionInput,
};

export type CancelMissionMutation = {
  cancelMission?:  {
    __typename?: "Mission",
    actualArrivalTime?: string | null,
    actualStartTime?: string | null,
    createdAt: string,
    description?: string | null,
    events?:  Array< {
      __typename?: "MissionEvent",
      createdAt: string,
      position:  {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      },
      type: MissionEventType,
    } > | null,
    fleetId?: string | null,
    id: string,
    name: string,
    plannedArrivalTime?: string | null,
    progressDetails?:  {
      __typename?: "MissionProgressDetails",
      eta: string,
      remainingDistanceInMeters: number,
      traveledDistanceInMeters: number,
      updatedAt: string,
    } | null,
    route?:  {
      __typename?: "GeneratedRoute",
      createdAt: string,
      durationInSeconds: number,
      externalRouteId: string,
      landingHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      launchHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      predefinedRouteId: string,
      totalDistanceInMeters: number,
      updatedAt: string,
      waypoints:  Array< {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      } >,
    } | null,
    state:  {
      __typename?: "MissionState",
      updatedAt: string,
      value: MissionStateValue,
    },
    updatedAt: string,
    vin: string,
  } | null,
};

export type ContinueStreamMutationVariables = {
  input: ContinueStreamInput,
};

export type ContinueStreamMutation = {
  continueStream?:  {
    __typename?: "ContinueVideoStream",
    cameraID?: string | null,
    vin: string,
  } | null,
};

export type CreateHubMutationVariables = {
  input: CreateHubInput,
};

export type CreateHubMutation = {
  createHub?:  {
    __typename?: "Hub",
    active: boolean,
    address?: string | null,
    createdAt: string,
    id: string,
    name: string,
    position:  {
      __typename?: "Coordinate",
      latitude?: number | null,
      longitude?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type CreateUserMutationVariables = {
  input: CreateUserInput,
};

export type CreateUserMutation = {
  createUser?:  {
    __typename?: "User",
    city?: string | null,
    country?: string | null,
    createdAt: string,
    updatedAt: string,
    email: string,
    firstName: string,
    id: string,
    lastName: string,
    phone?: string | null,
    roles:  Array< {
      __typename?: "SystemRole",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
      claims:  Array< {
        __typename?: "RoleClaim",
        pattern: string,
        createdAt: string,
        updatedAt: string,
      } >,
      useWildcardClaims: boolean,
    } >,
    status: Status,
    teams?:  Array< {
      __typename?: "UserTeam",
      id: string,
      name: string,
    } > | null,
  } | null,
};

export type DeleteVehicleDeviationsByVinMutationVariables = {
  input: DeleteVehicleDeviationsInput,
};

export type DeleteVehicleDeviationsByVinMutation = {
  deleteVehicleDeviationsByVin?:  {
    __typename?: "Vehicle",
    activeMissionId?: string | null,
    adsState: AdsState,
    cameras:  Array< {
      __typename?: "Camera",
      id?: string | null,
      name: string,
    } >,
    connectivityStatus?:  {
      __typename?: "ConnectivityStatus",
      description?: string | null,
      expectedDisconnect?: boolean | null,
      latency?: number | null,
      reason?: Reason | null,
      state?: ConnectivityState | null,
    } | null,
    createdAt: string,
    customerId?: string | null,
    deviations:  Array< {
      __typename?: "Deviation",
      category: string,
      description: string,
      id: string,
      isBlocking: boolean,
      origin: string,
      sentAt: string,
      severity: Severity,
      relatedDeviations: Array< string | null >,
      resolvedAt?: string | null,
      state?: DeviationState | null,
    } >,
    drivingState: DrivingState,
    externalId: string,
    fleetId?: string | null,
    latestVehicleUpdate?: string | null,
    licensePlate?: string | null,
    mrmState:  {
      __typename?: "MRMState",
      updatedAt: string,
      startedAt?: string | null,
      value: MRMStateValue,
      triggerBy?: MrmTriggerValue | null,
      mrmExecutionPhase?: MrmExecutionPhase | null,
      mrmType?: MrmType | null,
      causes?:  Array< {
        __typename?: "DeviationCause",
        deviationId: string,
      } > | null,
      error?: Error | null,
    },
    name?: string | null,
    owners:  Array< {
      __typename?: "Owner",
      email: string,
      fullName: string,
      id: string,
      phoneNumber: string,
      position: string,
    } >,
    position?:  {
      __typename?: "Position",
      altitude?: number | null,
      heading?: number | null,
      latitude?: number | null,
      longitude?: number | null,
    } | null,
    driverMode?: DriverMode | null,
    speedInKmh?: number | null,
    speedInMs?: number | null,
    updatedAt: string,
    vin: string,
    weightInKg?: number | null,
  } | null,
};

export type ResetMissionMutationVariables = {
  input: ResetMissionInput,
};

export type ResetMissionMutation = {
  resetMission?:  {
    __typename?: "Mission",
    actualArrivalTime?: string | null,
    actualStartTime?: string | null,
    createdAt: string,
    description?: string | null,
    events?:  Array< {
      __typename?: "MissionEvent",
      createdAt: string,
      position:  {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      },
      type: MissionEventType,
    } > | null,
    fleetId?: string | null,
    id: string,
    name: string,
    plannedArrivalTime?: string | null,
    progressDetails?:  {
      __typename?: "MissionProgressDetails",
      eta: string,
      remainingDistanceInMeters: number,
      traveledDistanceInMeters: number,
      updatedAt: string,
    } | null,
    route?:  {
      __typename?: "GeneratedRoute",
      createdAt: string,
      durationInSeconds: number,
      externalRouteId: string,
      landingHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      launchHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      predefinedRouteId: string,
      totalDistanceInMeters: number,
      updatedAt: string,
      waypoints:  Array< {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      } >,
    } | null,
    state:  {
      __typename?: "MissionState",
      updatedAt: string,
      value: MissionStateValue,
    },
    updatedAt: string,
    vin: string,
  } | null,
};

export type TriggerVehicleCommandMutationVariables = {
  input: VehicleCommandInput,
};

export type TriggerVehicleCommandMutation = {
  triggerVehicleCommand:  {
    __typename?: "CommandResponse",
    command: Command,
    errorMessage?: string | null,
    invocationId: string,
    isSuccess: boolean,
    receivedByVehicleAt: string,
    sentToVehicleAt: string,
    vin: string,
  },
};

export type UpdateHubMutationVariables = {
  input: UpdateHubInput,
};

export type UpdateHubMutation = {
  updateHub?:  {
    __typename?: "Hub",
    active: boolean,
    address?: string | null,
    createdAt: string,
    id: string,
    name: string,
    position:  {
      __typename?: "Coordinate",
      latitude?: number | null,
      longitude?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type UpdatedMissionMutationVariables = {
  input: UpdatedMissionInput,
};

export type UpdatedMissionMutation = {
  updatedMission?:  {
    __typename?: "Mission",
    actualArrivalTime?: string | null,
    actualStartTime?: string | null,
    createdAt: string,
    description?: string | null,
    events?:  Array< {
      __typename?: "MissionEvent",
      createdAt: string,
      position:  {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      },
      type: MissionEventType,
    } > | null,
    fleetId?: string | null,
    id: string,
    name: string,
    plannedArrivalTime?: string | null,
    progressDetails?:  {
      __typename?: "MissionProgressDetails",
      eta: string,
      remainingDistanceInMeters: number,
      traveledDistanceInMeters: number,
      updatedAt: string,
    } | null,
    route?:  {
      __typename?: "GeneratedRoute",
      createdAt: string,
      durationInSeconds: number,
      externalRouteId: string,
      landingHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      launchHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      predefinedRouteId: string,
      totalDistanceInMeters: number,
      updatedAt: string,
      waypoints:  Array< {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      } >,
    } | null,
    state:  {
      __typename?: "MissionState",
      updatedAt: string,
      value: MissionStateValue,
    },
    updatedAt: string,
    vin: string,
  } | null,
};

export type UpdatedVehicleMutationVariables = {
  input?: UpdatedVehicleInput | null,
};

export type UpdatedVehicleMutation = {
  updatedVehicle?:  {
    __typename?: "Vehicle",
    activeMissionId?: string | null,
    adsState: AdsState,
    cameras:  Array< {
      __typename?: "Camera",
      id?: string | null,
      name: string,
    } >,
    connectivityStatus?:  {
      __typename?: "ConnectivityStatus",
      description?: string | null,
      expectedDisconnect?: boolean | null,
      latency?: number | null,
      reason?: Reason | null,
      state?: ConnectivityState | null,
    } | null,
    createdAt: string,
    customerId?: string | null,
    deviations:  Array< {
      __typename?: "Deviation",
      category: string,
      description: string,
      id: string,
      isBlocking: boolean,
      origin: string,
      sentAt: string,
      severity: Severity,
      relatedDeviations: Array< string | null >,
      resolvedAt?: string | null,
      state?: DeviationState | null,
    } >,
    drivingState: DrivingState,
    externalId: string,
    fleetId?: string | null,
    latestVehicleUpdate?: string | null,
    licensePlate?: string | null,
    mrmState:  {
      __typename?: "MRMState",
      updatedAt: string,
      startedAt?: string | null,
      value: MRMStateValue,
      triggerBy?: MrmTriggerValue | null,
      mrmExecutionPhase?: MrmExecutionPhase | null,
      mrmType?: MrmType | null,
      causes?:  Array< {
        __typename?: "DeviationCause",
        deviationId: string,
      } > | null,
      error?: Error | null,
    },
    name?: string | null,
    owners:  Array< {
      __typename?: "Owner",
      email: string,
      fullName: string,
      id: string,
      phoneNumber: string,
      position: string,
    } >,
    position?:  {
      __typename?: "Position",
      altitude?: number | null,
      heading?: number | null,
      latitude?: number | null,
      longitude?: number | null,
    } | null,
    driverMode?: DriverMode | null,
    speedInKmh?: number | null,
    speedInMs?: number | null,
    updatedAt: string,
    vin: string,
    weightInKg?: number | null,
  } | null,
};

export type UpdatedVehicleByVinMutationVariables = {
  input?: UpdatedVehicleByVinInput | null,
};

export type UpdatedVehicleByVinMutation = {
  updatedVehicleByVin?:  {
    __typename?: "Vehicle",
    activeMissionId?: string | null,
    adsState: AdsState,
    cameras:  Array< {
      __typename?: "Camera",
      id?: string | null,
      name: string,
    } >,
    connectivityStatus?:  {
      __typename?: "ConnectivityStatus",
      description?: string | null,
      expectedDisconnect?: boolean | null,
      latency?: number | null,
      reason?: Reason | null,
      state?: ConnectivityState | null,
    } | null,
    createdAt: string,
    customerId?: string | null,
    deviations:  Array< {
      __typename?: "Deviation",
      category: string,
      description: string,
      id: string,
      isBlocking: boolean,
      origin: string,
      sentAt: string,
      severity: Severity,
      relatedDeviations: Array< string | null >,
      resolvedAt?: string | null,
      state?: DeviationState | null,
    } >,
    drivingState: DrivingState,
    externalId: string,
    fleetId?: string | null,
    latestVehicleUpdate?: string | null,
    licensePlate?: string | null,
    mrmState:  {
      __typename?: "MRMState",
      updatedAt: string,
      startedAt?: string | null,
      value: MRMStateValue,
      triggerBy?: MrmTriggerValue | null,
      mrmExecutionPhase?: MrmExecutionPhase | null,
      mrmType?: MrmType | null,
      causes?:  Array< {
        __typename?: "DeviationCause",
        deviationId: string,
      } > | null,
      error?: Error | null,
    },
    name?: string | null,
    owners:  Array< {
      __typename?: "Owner",
      email: string,
      fullName: string,
      id: string,
      phoneNumber: string,
      position: string,
    } >,
    position?:  {
      __typename?: "Position",
      altitude?: number | null,
      heading?: number | null,
      latitude?: number | null,
      longitude?: number | null,
    } | null,
    driverMode?: DriverMode | null,
    speedInKmh?: number | null,
    speedInMs?: number | null,
    updatedAt: string,
    vin: string,
    weightInKg?: number | null,
  } | null,
};

export type UpdatedVideoStreamingErrorMutationVariables = {
  input: UpdatedVideoStreamingErrorInput,
};

export type UpdatedVideoStreamingErrorMutation = {
  updatedVideoStreamingError?:  {
    __typename?: "VideoStreamingError",
    cameraID?: string | null,
    errorCode: VideoStreamingErrorCode,
    errorMessage?: string | null,
    vin: string,
  } | null,
};

export type UpdateFleetByIdMutationVariables = {
  input: UpdatedFleetInput,
};

export type UpdateFleetByIdMutation = {
  updateFleetById?:  {
    __typename?: "SystemFleet",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    teams?:  Array< {
      __typename?: "TeamInfo",
      id: string,
      name: string,
    } > | null,
    numberOfVehicles: number,
  } | null,
};

export type UpdateUserByIdMutationVariables = {
  input: UpdatedUserInput,
};

export type UpdateUserByIdMutation = {
  updateUserById?:  {
    __typename?: "User",
    city?: string | null,
    country?: string | null,
    createdAt: string,
    updatedAt: string,
    email: string,
    firstName: string,
    id: string,
    lastName: string,
    phone?: string | null,
    roles:  Array< {
      __typename?: "SystemRole",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
      claims:  Array< {
        __typename?: "RoleClaim",
        pattern: string,
        createdAt: string,
        updatedAt: string,
      } >,
      useWildcardClaims: boolean,
    } >,
    status: Status,
    teams?:  Array< {
      __typename?: "UserTeam",
      id: string,
      name: string,
    } > | null,
  } | null,
};

export type ResetPasswordByIdMutationVariables = {
  input: string,
};

export type ResetPasswordByIdMutation = {
  resetPasswordById: ( {
      __typename?: "ResetPasswordSuccessful",
      statusCode: number,
    } | {
      __typename?: "UserNotActiveError",
      statusCode: number,
      errorCode: string,
    } | {
      __typename?: "ValidationError",
      statusCode: number,
      errorCode: string,
    } | {
      __typename?: "SystemError",
      statusCode: number,
      errorCode: string,
    } | {
      __typename?: "NotFoundError",
      statusCode: number,
      errorCode: string,
    }
  ),
};

export type DeleteUserByIdMutationVariables = {
  input: string,
};

export type DeleteUserByIdMutation = {
  deleteUserById: ( {
      __typename?: "DeleteUserSuccessful",
      statusCode: number,
    } | {
      __typename?: "SelfDeleteError",
      statusCode: number,
      errorCode: string,
    } | {
      __typename?: "ValidationError",
      statusCode: number,
      errorCode: string,
    } | {
      __typename?: "SystemError",
      statusCode: number,
      errorCode: string,
    } | {
      __typename?: "NotFoundError",
      statusCode: number,
      errorCode: string,
    }
  ),
};

export type CreateFleetMutationVariables = {
  input: CreateFleetInput,
};

export type CreateFleetMutation = {
  createFleet?:  {
    __typename?: "SystemFleet",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    teams?:  Array< {
      __typename?: "TeamInfo",
      id: string,
      name: string,
    } > | null,
    numberOfVehicles: number,
  } | null,
};

export type CreateTeamMutationVariables = {
  input: CreateTeamInput,
};

export type CreateTeamMutation = {
  createTeam?:  {
    __typename?: "Team",
    id: string,
    name: string,
    users?: Array< string > | null,
    fleets?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdateTeamMutationVariables = {
  input: UpdateTeamInput,
};

export type UpdateTeamMutation = {
  updateTeam?:  {
    __typename?: "Team",
    id: string,
    name: string,
    users?: Array< string > | null,
    fleets?: Array< string > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type UpdatedMissionV2MutationVariables = {
  input: UpdatedMissionInputV2,
};

export type UpdatedMissionV2Mutation = {
  updatedMissionV2?:  {
    __typename?: "MissionV2",
    id: string,
    vin: string,
    timestamp: string,
    version: string,
    actualArrivalTime?: string | null,
    actualStartTime?: string | null,
    description?: string | null,
    events?:  Array< {
      __typename?: "MissionEvent",
      createdAt: string,
      position:  {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      },
      type: MissionEventType,
    } > | null,
    fleetId: string,
    name: string,
    plannedArrivalTime?: string | null,
    progressDetails?:  {
      __typename?: "MissionProgressDetailsFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "MissionProgressDetailsValueV2",
        eta: string,
        remainingDistanceInMeters: number,
        traveledDistanceInMeters: number,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    route?:  {
      __typename?: "GeneratedRouteV2",
      createdAt: string,
      durationInSeconds: number,
      externalRouteId: string,
      landingHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      launchHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      predefinedRouteId: string,
      totalDistanceInMeters: number,
      updatedAt: string,
      positions:  Array< {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      } >,
    } | null,
    state?:  {
      __typename?: "MissionStateFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "MissionStateValueV2",
        state: MissionStateValue,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
  } | null,
};

export type UpdatedVehicleV2MutationVariables = {
  input: UpdatedVehicleInputV2,
};

export type UpdatedVehicleV2Mutation = {
  updatedVehicleV2?:  {
    __typename?: "VehicleV2",
    vin: string,
    timestamp: string,
    activeMissionId?:  {
      __typename?: "StringFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "StringValueV2",
        data: string,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    adsState?:  {
      __typename?: "AdsStateFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "AdsStateValueV2",
        state: AdsState,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    connectivityStatus?:  {
      __typename?: "ConnectivityStatusFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "ConnectivityStatusValueV2",
        expectDisconnection: boolean,
        latency?: number | null,
        state?: ConnectivityState | null,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    deviations?:  Array< {
      __typename?: "DeviationsFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "DeviationsValueV2",
        deviation:  {
          __typename?: "Deviation",
          category: string,
          description: string,
          id: string,
          isBlocking: boolean,
          origin: string,
          sentAt: string,
          severity: Severity,
          relatedDeviations: Array< string | null >,
          resolvedAt?: string | null,
          state?: DeviationState | null,
        },
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null > | null,
    driverMode?:  {
      __typename?: "DriverModeFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "DriverModeValueV2",
        mode: DriverMode,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    drivingState?:  {
      __typename?: "DrivingStateFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "DrivingStateValueV2",
        state: DrivingState,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    fleetId?: string | null,
    latestVehicleUpdate?: string | null,
    licensePlate?: string | null,
    mrmState?:  {
      __typename?: "MrmStateFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "MrmStateValueV2",
        data:  {
          __typename?: "MrmStateValueDataV2",
          value: MRMStateValue,
          executionPhase?: MrmExecutionPhase | null,
          causes?: Array< string | null > | null,
          startedAt?: string | null,
          triggerBy?: MrmTriggerValue | null,
          mrmType?: MrmType | null,
        },
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    name: string,
    owners:  Array< {
      __typename?: "Owner",
      email: string,
      fullName: string,
      id: string,
      phoneNumber: string,
      position: string,
    } >,
    position?:  {
      __typename?: "PositionFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "PositionValueV2",
        position:  {
          __typename?: "Position",
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    speedMs?:  {
      __typename?: "SpeedMsFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "SpeedMsValueV2",
        speedMs: number,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
  } | null,
};

export type DeleteVehicleDeviationsByVinV2MutationVariables = {
  input: DeleteVehicleDeviationsInput,
};

export type DeleteVehicleDeviationsByVinV2Mutation = {
  deleteVehicleDeviationsByVinV2: ( {
      __typename?: "VehicleV2",
      vin: string,
      timestamp: string,
      activeMissionId?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          data: string,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      adsState?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          state: AdsState,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      connectivityStatus?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          expectDisconnection: boolean,
          latency?: number | null,
          state?: ConnectivityState | null,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      deviations?:  Array< {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          deviation:  {
            __typename?: string,
            category: string,
            description: string,
            id: string,
            isBlocking: boolean,
            origin: string,
            sentAt: string,
            severity: Severity,
            relatedDeviations: Array< string | null >,
            resolvedAt?: string | null,
            state?: DeviationState | null,
          },
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null > | null,
      driverMode?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          mode: DriverMode,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      drivingState?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          state: DrivingState,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      fleetId?: string | null,
      latestVehicleUpdate?: string | null,
      licensePlate?: string | null,
      mrmState?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          data:  {
            __typename?: string,
            value: MRMStateValue,
            executionPhase?: MrmExecutionPhase | null,
            causes?: Array< string | null > | null,
            startedAt?: string | null,
            triggerBy?: MrmTriggerValue | null,
            mrmType?: MrmType | null,
          },
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      name: string,
      owners:  Array< {
        __typename?: string,
        email: string,
        fullName: string,
        id: string,
        phoneNumber: string,
        position: string,
      } >,
      position?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          position:  {
            __typename?: string,
            altitude?: number | null,
            heading?: number | null,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      speedMs?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          speedMs: number,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type CreateMissionV2MutationVariables = {
  input: CreateMissionInputV2,
};

export type CreateMissionV2Mutation = {
  createMissionV2: ( {
      __typename?: "MissionV2",
      id: string,
      vin: string,
      timestamp: string,
      version: string,
      actualArrivalTime?: string | null,
      actualStartTime?: string | null,
      description?: string | null,
      events?:  Array< {
        __typename?: string,
        createdAt: string,
        position:  {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        },
        type: MissionEventType,
      } > | null,
      fleetId: string,
      name: string,
      plannedArrivalTime?: string | null,
      progressDetails?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          eta: string,
          remainingDistanceInMeters: number,
          traveledDistanceInMeters: number,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      route?:  {
        __typename?: string,
        createdAt: string,
        durationInSeconds: number,
        externalRouteId: string,
        landingHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        launchHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        predefinedRouteId: string,
        totalDistanceInMeters: number,
        updatedAt: string,
        positions:  Array< {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        } >,
      } | null,
      state?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          state: MissionStateValue,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type StartMissionV2MutationVariables = {
  input: StartMissionInput,
};

export type StartMissionV2Mutation = {
  startMissionV2: ( {
      __typename?: "MissionV2",
      id: string,
      vin: string,
      timestamp: string,
      version: string,
      actualArrivalTime?: string | null,
      actualStartTime?: string | null,
      description?: string | null,
      events?:  Array< {
        __typename?: string,
        createdAt: string,
        position:  {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        },
        type: MissionEventType,
      } > | null,
      fleetId: string,
      name: string,
      plannedArrivalTime?: string | null,
      progressDetails?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          eta: string,
          remainingDistanceInMeters: number,
          traveledDistanceInMeters: number,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      route?:  {
        __typename?: string,
        createdAt: string,
        durationInSeconds: number,
        externalRouteId: string,
        landingHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        launchHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        predefinedRouteId: string,
        totalDistanceInMeters: number,
        updatedAt: string,
        positions:  Array< {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        } >,
      } | null,
      state?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          state: MissionStateValue,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type ResetMissionV2MutationVariables = {
  input: ResetMissionInput,
};

export type ResetMissionV2Mutation = {
  resetMissionV2: ( {
      __typename?: "MissionV2",
      id: string,
      vin: string,
      timestamp: string,
      version: string,
      actualArrivalTime?: string | null,
      actualStartTime?: string | null,
      description?: string | null,
      events?:  Array< {
        __typename?: string,
        createdAt: string,
        position:  {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        },
        type: MissionEventType,
      } > | null,
      fleetId: string,
      name: string,
      plannedArrivalTime?: string | null,
      progressDetails?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          eta: string,
          remainingDistanceInMeters: number,
          traveledDistanceInMeters: number,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      route?:  {
        __typename?: string,
        createdAt: string,
        durationInSeconds: number,
        externalRouteId: string,
        landingHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        launchHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        predefinedRouteId: string,
        totalDistanceInMeters: number,
        updatedAt: string,
        positions:  Array< {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        } >,
      } | null,
      state?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          state: MissionStateValue,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type ArchiveMissionV2MutationVariables = {
  input: ArchiveMissionInput,
};

export type ArchiveMissionV2Mutation = {
  archiveMissionV2: ( {
      __typename?: "MissionV2",
      id: string,
      vin: string,
      timestamp: string,
      version: string,
      actualArrivalTime?: string | null,
      actualStartTime?: string | null,
      description?: string | null,
      events?:  Array< {
        __typename?: string,
        createdAt: string,
        position:  {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        },
        type: MissionEventType,
      } > | null,
      fleetId: string,
      name: string,
      plannedArrivalTime?: string | null,
      progressDetails?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          eta: string,
          remainingDistanceInMeters: number,
          traveledDistanceInMeters: number,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      route?:  {
        __typename?: string,
        createdAt: string,
        durationInSeconds: number,
        externalRouteId: string,
        landingHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        launchHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        predefinedRouteId: string,
        totalDistanceInMeters: number,
        updatedAt: string,
        positions:  Array< {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        } >,
      } | null,
      state?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          state: MissionStateValue,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type CancelMissionV2MutationVariables = {
  input: CancelMissionInput,
};

export type CancelMissionV2Mutation = {
  cancelMissionV2: ( {
      __typename?: "MissionV2",
      id: string,
      vin: string,
      timestamp: string,
      version: string,
      actualArrivalTime?: string | null,
      actualStartTime?: string | null,
      description?: string | null,
      events?:  Array< {
        __typename?: string,
        createdAt: string,
        position:  {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        },
        type: MissionEventType,
      } > | null,
      fleetId: string,
      name: string,
      plannedArrivalTime?: string | null,
      progressDetails?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          eta: string,
          remainingDistanceInMeters: number,
          traveledDistanceInMeters: number,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      route?:  {
        __typename?: string,
        createdAt: string,
        durationInSeconds: number,
        externalRouteId: string,
        landingHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        launchHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        predefinedRouteId: string,
        totalDistanceInMeters: number,
        updatedAt: string,
        positions:  Array< {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        } >,
      } | null,
      state?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          state: MissionStateValue,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type UpdatedMissionV3MutationVariables = {
  input: UpdatedMissionInputV3,
};

export type UpdatedMissionV3Mutation = {
  updatedMissionV3?:  {
    __typename?: "MissionUpdateV3",
    vin: string,
    fleetId?: string | null,
    payload: ( {
        __typename?: "MissionV2",
        id: string,
        vin: string,
        timestamp: string,
        version: string,
        actualArrivalTime?: string | null,
        actualStartTime?: string | null,
        description?: string | null,
        events?:  Array< {
          __typename?: string,
          createdAt: string,
          position:  {
            __typename?: string,
            altitude?: number | null,
            heading?: number | null,
            latitude?: number | null,
            longitude?: number | null,
          },
          type: MissionEventType,
        } > | null,
        fleetId: string,
        name: string,
        plannedArrivalTime?: string | null,
        progressDetails?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            eta: string,
            remainingDistanceInMeters: number,
            traveledDistanceInMeters: number,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        route?:  {
          __typename?: string,
          createdAt: string,
          durationInSeconds: number,
          externalRouteId: string,
          landingHub:  {
            __typename?: string,
            active: boolean,
            address?: string | null,
            createdAt: string,
            id: string,
            name: string,
            position:  {
              __typename?: string,
              latitude?: number | null,
              longitude?: number | null,
            },
            updatedAt: string,
          },
          launchHub:  {
            __typename?: string,
            active: boolean,
            address?: string | null,
            createdAt: string,
            id: string,
            name: string,
            position:  {
              __typename?: string,
              latitude?: number | null,
              longitude?: number | null,
            },
            updatedAt: string,
          },
          predefinedRouteId: string,
          totalDistanceInMeters: number,
          updatedAt: string,
          positions:  Array< {
            __typename?: string,
            altitude?: number | null,
            heading?: number | null,
            latitude?: number | null,
            longitude?: number | null,
          } >,
        } | null,
        state?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            state: MissionStateValue,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
      } | {
        __typename?: "MissionUnassigned",
        vin: string,
        timestamp: string,
        version: string,
        fleetId: string,
      }
    ),
  } | null,
};

export type GetCameraImageByVINQueryVariables = {
  cameraID?: string | null,
  vin: string,
};

export type GetCameraImageByVINQuery = {
  getCameraImageByVIN?:  {
    __typename?: "CameraImage",
    timestamp: string,
    value: string,
  } | null,
};

export type GetHealthStatusQueryVariables = {
};

export type GetHealthStatusQuery = {
  getHealthStatus:  {
    __typename?: "HealthStatusInformation",
    status: HealthStatus,
  },
};

export type GetHubQueryVariables = {
  id: string,
};

export type GetHubQuery = {
  getHub?:  {
    __typename?: "Hub",
    active: boolean,
    address?: string | null,
    createdAt: string,
    id: string,
    name: string,
    position:  {
      __typename?: "Coordinate",
      latitude?: number | null,
      longitude?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type GetMissionQueryVariables = {
  id: string,
};

export type GetMissionQuery = {
  getMission?:  {
    __typename?: "Mission",
    actualArrivalTime?: string | null,
    actualStartTime?: string | null,
    createdAt: string,
    description?: string | null,
    events?:  Array< {
      __typename?: "MissionEvent",
      createdAt: string,
      position:  {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      },
      type: MissionEventType,
    } > | null,
    fleetId?: string | null,
    id: string,
    name: string,
    plannedArrivalTime?: string | null,
    progressDetails?:  {
      __typename?: "MissionProgressDetails",
      eta: string,
      remainingDistanceInMeters: number,
      traveledDistanceInMeters: number,
      updatedAt: string,
    } | null,
    route?:  {
      __typename?: "GeneratedRoute",
      createdAt: string,
      durationInSeconds: number,
      externalRouteId: string,
      landingHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      launchHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      predefinedRouteId: string,
      totalDistanceInMeters: number,
      updatedAt: string,
      waypoints:  Array< {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      } >,
    } | null,
    state:  {
      __typename?: "MissionState",
      updatedAt: string,
      value: MissionStateValue,
    },
    updatedAt: string,
    vin: string,
  } | null,
};

export type GetUserQueryVariables = {
  id: string,
};

export type GetUserQuery = {
  getUser?:  {
    __typename?: "User",
    city?: string | null,
    country?: string | null,
    createdAt: string,
    updatedAt: string,
    email: string,
    firstName: string,
    id: string,
    lastName: string,
    phone?: string | null,
    roles:  Array< {
      __typename?: "SystemRole",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
      claims:  Array< {
        __typename?: "RoleClaim",
        pattern: string,
        createdAt: string,
        updatedAt: string,
      } >,
      useWildcardClaims: boolean,
    } >,
    status: Status,
    teams?:  Array< {
      __typename?: "UserTeam",
      id: string,
      name: string,
    } > | null,
  } | null,
};

export type GetVehicleByVINQueryVariables = {
  vin: string,
};

export type GetVehicleByVINQuery = {
  getVehicleByVIN?:  {
    __typename?: "Vehicle",
    activeMissionId?: string | null,
    adsState: AdsState,
    cameras:  Array< {
      __typename?: "Camera",
      id?: string | null,
      name: string,
    } >,
    connectivityStatus?:  {
      __typename?: "ConnectivityStatus",
      description?: string | null,
      expectedDisconnect?: boolean | null,
      latency?: number | null,
      reason?: Reason | null,
      state?: ConnectivityState | null,
    } | null,
    createdAt: string,
    customerId?: string | null,
    deviations:  Array< {
      __typename?: "Deviation",
      category: string,
      description: string,
      id: string,
      isBlocking: boolean,
      origin: string,
      sentAt: string,
      severity: Severity,
      relatedDeviations: Array< string | null >,
      resolvedAt?: string | null,
      state?: DeviationState | null,
    } >,
    drivingState: DrivingState,
    externalId: string,
    fleetId?: string | null,
    latestVehicleUpdate?: string | null,
    licensePlate?: string | null,
    mrmState:  {
      __typename?: "MRMState",
      updatedAt: string,
      startedAt?: string | null,
      value: MRMStateValue,
      triggerBy?: MrmTriggerValue | null,
      mrmExecutionPhase?: MrmExecutionPhase | null,
      mrmType?: MrmType | null,
      causes?:  Array< {
        __typename?: "DeviationCause",
        deviationId: string,
      } > | null,
      error?: Error | null,
    },
    name?: string | null,
    owners:  Array< {
      __typename?: "Owner",
      email: string,
      fullName: string,
      id: string,
      phoneNumber: string,
      position: string,
    } >,
    position?:  {
      __typename?: "Position",
      altitude?: number | null,
      heading?: number | null,
      latitude?: number | null,
      longitude?: number | null,
    } | null,
    driverMode?: DriverMode | null,
    speedInKmh?: number | null,
    speedInMs?: number | null,
    updatedAt: string,
    vin: string,
    weightInKg?: number | null,
  } | null,
};

export type GetVideoStreamingURLQueryVariables = {
  cameraID?: string | null,
  vin: string,
};

export type GetVideoStreamingURLQuery = {
  getVideoStreamingURL?:  {
    __typename?: "VideoStream",
    cameraID?: string | null,
    streamingURL: string,
    vin: string,
  } | null,
};

export type ListHubsQueryVariables = {
};

export type ListHubsQuery = {
  listHubs:  Array< {
    __typename?: "Hub",
    active: boolean,
    address?: string | null,
    createdAt: string,
    id: string,
    name: string,
    position:  {
      __typename?: "Coordinate",
      latitude?: number | null,
      longitude?: number | null,
    },
    updatedAt: string,
  } >,
};

export type ListRoutesQueryVariables = {
};

export type ListRoutesQuery = {
  listRoutes:  Array< {
    __typename?: "Route",
    averageDuration: number,
    createdAt: string,
    distance: number,
    id: string,
    landingHub:  {
      __typename?: "Hub",
      active: boolean,
      address?: string | null,
      createdAt: string,
      id: string,
      name: string,
      position:  {
        __typename?: "Coordinate",
        latitude?: number | null,
        longitude?: number | null,
      },
      updatedAt: string,
    },
    launchHub:  {
      __typename?: "Hub",
      active: boolean,
      address?: string | null,
      createdAt: string,
      id: string,
      name: string,
      position:  {
        __typename?: "Coordinate",
        latitude?: number | null,
        longitude?: number | null,
      },
      updatedAt: string,
    },
    updatedAt: string,
  } >,
};

export type ListUsersQueryVariables = {
};

export type ListUsersQuery = {
  listUsers?:  Array< {
    __typename?: "User",
    city?: string | null,
    country?: string | null,
    createdAt: string,
    updatedAt: string,
    email: string,
    firstName: string,
    id: string,
    lastName: string,
    phone?: string | null,
    roles:  Array< {
      __typename?: "SystemRole",
      id: string,
      name: string,
      createdAt: string,
      updatedAt: string,
      claims:  Array< {
        __typename?: "RoleClaim",
        pattern: string,
        createdAt: string,
        updatedAt: string,
      } >,
      useWildcardClaims: boolean,
    } >,
    status: Status,
    teams?:  Array< {
      __typename?: "UserTeam",
      id: string,
      name: string,
    } > | null,
  } > | null,
};

export type ListVehiclesQueryVariables = {
};

export type ListVehiclesQuery = {
  listVehicles:  Array< {
    __typename?: "Vehicle",
    activeMissionId?: string | null,
    adsState: AdsState,
    cameras:  Array< {
      __typename?: "Camera",
      id?: string | null,
      name: string,
    } >,
    connectivityStatus?:  {
      __typename?: "ConnectivityStatus",
      description?: string | null,
      expectedDisconnect?: boolean | null,
      latency?: number | null,
      reason?: Reason | null,
      state?: ConnectivityState | null,
    } | null,
    createdAt: string,
    customerId?: string | null,
    deviations:  Array< {
      __typename?: "Deviation",
      category: string,
      description: string,
      id: string,
      isBlocking: boolean,
      origin: string,
      sentAt: string,
      severity: Severity,
      relatedDeviations: Array< string | null >,
      resolvedAt?: string | null,
      state?: DeviationState | null,
    } >,
    drivingState: DrivingState,
    externalId: string,
    fleetId?: string | null,
    latestVehicleUpdate?: string | null,
    licensePlate?: string | null,
    mrmState:  {
      __typename?: "MRMState",
      updatedAt: string,
      startedAt?: string | null,
      value: MRMStateValue,
      triggerBy?: MrmTriggerValue | null,
      mrmExecutionPhase?: MrmExecutionPhase | null,
      mrmType?: MrmType | null,
      causes?:  Array< {
        __typename?: "DeviationCause",
        deviationId: string,
      } > | null,
      error?: Error | null,
    },
    name?: string | null,
    owners:  Array< {
      __typename?: "Owner",
      email: string,
      fullName: string,
      id: string,
      phoneNumber: string,
      position: string,
    } >,
    position?:  {
      __typename?: "Position",
      altitude?: number | null,
      heading?: number | null,
      latitude?: number | null,
      longitude?: number | null,
    } | null,
    driverMode?: DriverMode | null,
    speedInKmh?: number | null,
    speedInMs?: number | null,
    updatedAt: string,
    vin: string,
    weightInKg?: number | null,
  } >,
};

export type ListVehiclesByFleetIdQueryVariables = {
  fleetId: string,
};

export type ListVehiclesByFleetIdQuery = {
  listVehiclesByFleetId?:  Array< {
    __typename?: "Vehicle",
    activeMissionId?: string | null,
    adsState: AdsState,
    cameras:  Array< {
      __typename?: "Camera",
      id?: string | null,
      name: string,
    } >,
    connectivityStatus?:  {
      __typename?: "ConnectivityStatus",
      description?: string | null,
      expectedDisconnect?: boolean | null,
      latency?: number | null,
      reason?: Reason | null,
      state?: ConnectivityState | null,
    } | null,
    createdAt: string,
    customerId?: string | null,
    deviations:  Array< {
      __typename?: "Deviation",
      category: string,
      description: string,
      id: string,
      isBlocking: boolean,
      origin: string,
      sentAt: string,
      severity: Severity,
      relatedDeviations: Array< string | null >,
      resolvedAt?: string | null,
      state?: DeviationState | null,
    } >,
    drivingState: DrivingState,
    externalId: string,
    fleetId?: string | null,
    latestVehicleUpdate?: string | null,
    licensePlate?: string | null,
    mrmState:  {
      __typename?: "MRMState",
      updatedAt: string,
      startedAt?: string | null,
      value: MRMStateValue,
      triggerBy?: MrmTriggerValue | null,
      mrmExecutionPhase?: MrmExecutionPhase | null,
      mrmType?: MrmType | null,
      causes?:  Array< {
        __typename?: "DeviationCause",
        deviationId: string,
      } > | null,
      error?: Error | null,
    },
    name?: string | null,
    owners:  Array< {
      __typename?: "Owner",
      email: string,
      fullName: string,
      id: string,
      phoneNumber: string,
      position: string,
    } >,
    position?:  {
      __typename?: "Position",
      altitude?: number | null,
      heading?: number | null,
      latitude?: number | null,
      longitude?: number | null,
    } | null,
    driverMode?: DriverMode | null,
    speedInKmh?: number | null,
    speedInMs?: number | null,
    updatedAt: string,
    vin: string,
    weightInKg?: number | null,
  } | null > | null,
};

export type GetSystemTeamInfoQueryVariables = {
  id: string,
};

export type GetSystemTeamInfoQuery = {
  getSystemTeamInfo?:  {
    __typename?: "SystemTeamInfo",
    id: string,
    users?:  Array< {
      __typename?: "TeamUserInfo",
      id: string,
      firstName: string,
      lastName: string,
    } > | null,
    fleets?:  Array< {
      __typename?: "TeamFleetInfo",
      id: string,
      name: string,
    } > | null,
    createdAt: string,
    updatedAt: string,
  } | null,
};

export type ListSystemTeamsQueryVariables = {
};

export type ListSystemTeamsQuery = {
  listSystemTeams?:  Array< {
    __typename?: "SystemTeam",
    id: string,
    name: string,
    numberOfUsers: number,
    numberOfFleets: number,
    createdAt: string,
    updatedAt: string,
  } > | null,
};

export type ListFleetsQueryVariables = {
};

export type ListFleetsQuery = {
  listFleets?:  Array< {
    __typename?: "SystemFleet",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    teams?:  Array< {
      __typename?: "TeamInfo",
      id: string,
      name: string,
    } > | null,
    numberOfVehicles: number,
  } | null > | null,
};

export type ListRolesQueryVariables = {
};

export type ListRolesQuery = {
  listRoles?:  Array< {
    __typename?: "SystemRole",
    id: string,
    name: string,
    createdAt: string,
    updatedAt: string,
    claims:  Array< {
      __typename?: "RoleClaim",
      pattern: string,
      createdAt: string,
      updatedAt: string,
    } >,
    useWildcardClaims: boolean,
  } > | null,
};

export type GetFleetByIdQueryVariables = {
  id: string,
};

export type GetFleetByIdQuery = {
  getFleetById?:  {
    __typename?: "SystemFleetDetail",
    fleetId: string,
    vehicles?:  Array< {
      __typename?: "VehicleInfo",
      vin: string,
      name: string,
    } | null > | null,
  } | null,
};

export type GetSystemVersionQueryVariables = {
};

export type GetSystemVersionQuery = {
  getSystemVersion?:  {
    __typename?: "SystemVersion",
    version: string,
    services?:  Array< {
      __typename?: "SystemVersionItem",
      service: string,
      version: string,
    } | null > | null,
  } | null,
};

export type GetMissionV2QueryVariables = {
  id: string,
};

export type GetMissionV2Query = {
  getMissionV2: ( {
      __typename?: "MissionV2",
      id: string,
      vin: string,
      timestamp: string,
      version: string,
      actualArrivalTime?: string | null,
      actualStartTime?: string | null,
      description?: string | null,
      events?:  Array< {
        __typename?: string,
        createdAt: string,
        position:  {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        },
        type: MissionEventType,
      } > | null,
      fleetId: string,
      name: string,
      plannedArrivalTime?: string | null,
      progressDetails?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          eta: string,
          remainingDistanceInMeters: number,
          traveledDistanceInMeters: number,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      route?:  {
        __typename?: string,
        createdAt: string,
        durationInSeconds: number,
        externalRouteId: string,
        landingHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        launchHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        predefinedRouteId: string,
        totalDistanceInMeters: number,
        updatedAt: string,
        positions:  Array< {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        } >,
      } | null,
      state?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          state: MissionStateValue,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type GetActiveMissionV2QueryVariables = {
  vin: string,
};

export type GetActiveMissionV2Query = {
  getActiveMissionV2: ( {
      __typename?: "MissionV2",
      id: string,
      vin: string,
      timestamp: string,
      version: string,
      actualArrivalTime?: string | null,
      actualStartTime?: string | null,
      description?: string | null,
      events?:  Array< {
        __typename?: string,
        createdAt: string,
        position:  {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        },
        type: MissionEventType,
      } > | null,
      fleetId: string,
      name: string,
      plannedArrivalTime?: string | null,
      progressDetails?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          eta: string,
          remainingDistanceInMeters: number,
          traveledDistanceInMeters: number,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      route?:  {
        __typename?: string,
        createdAt: string,
        durationInSeconds: number,
        externalRouteId: string,
        landingHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        launchHub:  {
          __typename?: string,
          active: boolean,
          address?: string | null,
          createdAt: string,
          id: string,
          name: string,
          position:  {
            __typename?: string,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        },
        predefinedRouteId: string,
        totalDistanceInMeters: number,
        updatedAt: string,
        positions:  Array< {
          __typename?: string,
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        } >,
      } | null,
      state?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          state: MissionStateValue,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type GetActiveMissionRouteV2QueryVariables = {
  vin: string,
};

export type GetActiveMissionRouteV2Query = {
  getActiveMissionRouteV2: ( {
      __typename?: "GeneratedRouteV2",
      createdAt: string,
      durationInSeconds: number,
      externalRouteId: string,
      landingHub:  {
        __typename?: string,
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: string,
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      launchHub:  {
        __typename?: string,
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: string,
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      predefinedRouteId: string,
      totalDistanceInMeters: number,
      updatedAt: string,
      positions:  Array< {
        __typename?: string,
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      } >,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type GetVehicleByVINV2QueryVariables = {
  vin: string,
};

export type GetVehicleByVINV2Query = {
  getVehicleByVINV2: ( {
      __typename?: "VehicleV2",
      vin: string,
      timestamp: string,
      activeMissionId?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          data: string,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      adsState?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          state: AdsState,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      connectivityStatus?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          expectDisconnection: boolean,
          latency?: number | null,
          state?: ConnectivityState | null,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      deviations?:  Array< {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          deviation:  {
            __typename?: string,
            category: string,
            description: string,
            id: string,
            isBlocking: boolean,
            origin: string,
            sentAt: string,
            severity: Severity,
            relatedDeviations: Array< string | null >,
            resolvedAt?: string | null,
            state?: DeviationState | null,
          },
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null > | null,
      driverMode?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          mode: DriverMode,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      drivingState?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          state: DrivingState,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      fleetId?: string | null,
      latestVehicleUpdate?: string | null,
      licensePlate?: string | null,
      mrmState?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          data:  {
            __typename?: string,
            value: MRMStateValue,
            executionPhase?: MrmExecutionPhase | null,
            causes?: Array< string | null > | null,
            startedAt?: string | null,
            triggerBy?: MrmTriggerValue | null,
            mrmType?: MrmType | null,
          },
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      name: string,
      owners:  Array< {
        __typename?: string,
        email: string,
        fullName: string,
        id: string,
        phoneNumber: string,
        position: string,
      } >,
      position?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          position:  {
            __typename?: string,
            altitude?: number | null,
            heading?: number | null,
            latitude?: number | null,
            longitude?: number | null,
          },
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
      speedMs?:  {
        __typename?: string,
        ttl?: number | null,
        value?:  {
          __typename?: string,
          speedMs: number,
          updatedAt: string,
        } | null,
        error?:  {
          __typename?: string,
          type: ErrorTypeV2,
          raisedAt: string,
        } | null,
      } | null,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type ListVehiclesV2QueryVariables = {
};

export type ListVehiclesV2Query = {
  listVehiclesV2: ( {
      __typename?: "VehicleList",
      items?:  Array< {
        __typename?: string,
        vin: string,
        timestamp: string,
        activeMissionId?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            data: string,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        adsState?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            state: AdsState,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        connectivityStatus?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            expectDisconnection: boolean,
            latency?: number | null,
            state?: ConnectivityState | null,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        deviations?:  Array< {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            deviation:  {
              __typename?: string,
              category: string,
              description: string,
              id: string,
              isBlocking: boolean,
              origin: string,
              sentAt: string,
              severity: Severity,
              relatedDeviations: Array< string | null >,
              resolvedAt?: string | null,
              state?: DeviationState | null,
            },
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null > | null,
        driverMode?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            mode: DriverMode,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        drivingState?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            state: DrivingState,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        fleetId?: string | null,
        latestVehicleUpdate?: string | null,
        licensePlate?: string | null,
        mrmState?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            data:  {
              __typename?: string,
              value: MRMStateValue,
              executionPhase?: MrmExecutionPhase | null,
              causes?: Array< string | null > | null,
              startedAt?: string | null,
              triggerBy?: MrmTriggerValue | null,
              mrmType?: MrmType | null,
            },
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        name: string,
        owners:  Array< {
          __typename?: string,
          email: string,
          fullName: string,
          id: string,
          phoneNumber: string,
          position: string,
        } >,
        position?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            position:  {
              __typename?: string,
              altitude?: number | null,
              heading?: number | null,
              latitude?: number | null,
              longitude?: number | null,
            },
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        speedMs?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            speedMs: number,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
      } | null > | null,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type ListVehiclesByFleetIdV2QueryVariables = {
  fleetId: string,
};

export type ListVehiclesByFleetIdV2Query = {
  listVehiclesByFleetIdV2: ( {
      __typename?: "VehicleList",
      items?:  Array< {
        __typename?: string,
        vin: string,
        timestamp: string,
        activeMissionId?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            data: string,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        adsState?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            state: AdsState,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        connectivityStatus?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            expectDisconnection: boolean,
            latency?: number | null,
            state?: ConnectivityState | null,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        deviations?:  Array< {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            deviation:  {
              __typename?: string,
              category: string,
              description: string,
              id: string,
              isBlocking: boolean,
              origin: string,
              sentAt: string,
              severity: Severity,
              relatedDeviations: Array< string | null >,
              resolvedAt?: string | null,
              state?: DeviationState | null,
            },
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null > | null,
        driverMode?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            mode: DriverMode,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        drivingState?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            state: DrivingState,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        fleetId?: string | null,
        latestVehicleUpdate?: string | null,
        licensePlate?: string | null,
        mrmState?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            data:  {
              __typename?: string,
              value: MRMStateValue,
              executionPhase?: MrmExecutionPhase | null,
              causes?: Array< string | null > | null,
              startedAt?: string | null,
              triggerBy?: MrmTriggerValue | null,
              mrmType?: MrmType | null,
            },
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        name: string,
        owners:  Array< {
          __typename?: string,
          email: string,
          fullName: string,
          id: string,
          phoneNumber: string,
          position: string,
        } >,
        position?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            position:  {
              __typename?: string,
              altitude?: number | null,
              heading?: number | null,
              latitude?: number | null,
              longitude?: number | null,
            },
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        speedMs?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            speedMs: number,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
      } | null > | null,
    } | {
      __typename?: "ErrorResponse",
      statusCode: number,
      errorCode: string,
    }
  ) | null,
};

export type OnUpdateHubSubscriptionVariables = {
};

export type OnUpdateHubSubscription = {
  onUpdateHub?:  {
    __typename?: "Hub",
    active: boolean,
    address?: string | null,
    createdAt: string,
    id: string,
    name: string,
    position:  {
      __typename?: "Coordinate",
      latitude?: number | null,
      longitude?: number | null,
    },
    updatedAt: string,
  } | null,
};

export type OnUpdateMissionSubscriptionVariables = {
  id: string,
};

export type OnUpdateMissionSubscription = {
  onUpdateMission?:  {
    __typename?: "Mission",
    actualArrivalTime?: string | null,
    actualStartTime?: string | null,
    createdAt: string,
    description?: string | null,
    events?:  Array< {
      __typename?: "MissionEvent",
      createdAt: string,
      position:  {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      },
      type: MissionEventType,
    } > | null,
    fleetId?: string | null,
    id: string,
    name: string,
    plannedArrivalTime?: string | null,
    progressDetails?:  {
      __typename?: "MissionProgressDetails",
      eta: string,
      remainingDistanceInMeters: number,
      traveledDistanceInMeters: number,
      updatedAt: string,
    } | null,
    route?:  {
      __typename?: "GeneratedRoute",
      createdAt: string,
      durationInSeconds: number,
      externalRouteId: string,
      landingHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      launchHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      predefinedRouteId: string,
      totalDistanceInMeters: number,
      updatedAt: string,
      waypoints:  Array< {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      } >,
    } | null,
    state:  {
      __typename?: "MissionState",
      updatedAt: string,
      value: MissionStateValue,
    },
    updatedAt: string,
    vin: string,
  } | null,
};

export type OnUpdateVehicleSubscriptionVariables = {
};

export type OnUpdateVehicleSubscription = {
  onUpdateVehicle?:  {
    __typename?: "Vehicle",
    activeMissionId?: string | null,
    adsState: AdsState,
    cameras:  Array< {
      __typename?: "Camera",
      id?: string | null,
      name: string,
    } >,
    connectivityStatus?:  {
      __typename?: "ConnectivityStatus",
      description?: string | null,
      expectedDisconnect?: boolean | null,
      latency?: number | null,
      reason?: Reason | null,
      state?: ConnectivityState | null,
    } | null,
    createdAt: string,
    customerId?: string | null,
    deviations:  Array< {
      __typename?: "Deviation",
      category: string,
      description: string,
      id: string,
      isBlocking: boolean,
      origin: string,
      sentAt: string,
      severity: Severity,
      relatedDeviations: Array< string | null >,
      resolvedAt?: string | null,
      state?: DeviationState | null,
    } >,
    drivingState: DrivingState,
    externalId: string,
    fleetId?: string | null,
    latestVehicleUpdate?: string | null,
    licensePlate?: string | null,
    mrmState:  {
      __typename?: "MRMState",
      updatedAt: string,
      startedAt?: string | null,
      value: MRMStateValue,
      triggerBy?: MrmTriggerValue | null,
      mrmExecutionPhase?: MrmExecutionPhase | null,
      mrmType?: MrmType | null,
      causes?:  Array< {
        __typename?: "DeviationCause",
        deviationId: string,
      } > | null,
      error?: Error | null,
    },
    name?: string | null,
    owners:  Array< {
      __typename?: "Owner",
      email: string,
      fullName: string,
      id: string,
      phoneNumber: string,
      position: string,
    } >,
    position?:  {
      __typename?: "Position",
      altitude?: number | null,
      heading?: number | null,
      latitude?: number | null,
      longitude?: number | null,
    } | null,
    driverMode?: DriverMode | null,
    speedInKmh?: number | null,
    speedInMs?: number | null,
    updatedAt: string,
    vin: string,
    weightInKg?: number | null,
  } | null,
};

export type OnUpdateVehicleByVinSubscriptionVariables = {
  vin: string,
};

export type OnUpdateVehicleByVinSubscription = {
  onUpdateVehicleByVin?:  {
    __typename?: "Vehicle",
    activeMissionId?: string | null,
    adsState: AdsState,
    cameras:  Array< {
      __typename?: "Camera",
      id?: string | null,
      name: string,
    } >,
    connectivityStatus?:  {
      __typename?: "ConnectivityStatus",
      description?: string | null,
      expectedDisconnect?: boolean | null,
      latency?: number | null,
      reason?: Reason | null,
      state?: ConnectivityState | null,
    } | null,
    createdAt: string,
    customerId?: string | null,
    deviations:  Array< {
      __typename?: "Deviation",
      category: string,
      description: string,
      id: string,
      isBlocking: boolean,
      origin: string,
      sentAt: string,
      severity: Severity,
      relatedDeviations: Array< string | null >,
      resolvedAt?: string | null,
      state?: DeviationState | null,
    } >,
    drivingState: DrivingState,
    externalId: string,
    fleetId?: string | null,
    latestVehicleUpdate?: string | null,
    licensePlate?: string | null,
    mrmState:  {
      __typename?: "MRMState",
      updatedAt: string,
      startedAt?: string | null,
      value: MRMStateValue,
      triggerBy?: MrmTriggerValue | null,
      mrmExecutionPhase?: MrmExecutionPhase | null,
      mrmType?: MrmType | null,
      causes?:  Array< {
        __typename?: "DeviationCause",
        deviationId: string,
      } > | null,
      error?: Error | null,
    },
    name?: string | null,
    owners:  Array< {
      __typename?: "Owner",
      email: string,
      fullName: string,
      id: string,
      phoneNumber: string,
      position: string,
    } >,
    position?:  {
      __typename?: "Position",
      altitude?: number | null,
      heading?: number | null,
      latitude?: number | null,
      longitude?: number | null,
    } | null,
    driverMode?: DriverMode | null,
    speedInKmh?: number | null,
    speedInMs?: number | null,
    updatedAt: string,
    vin: string,
    weightInKg?: number | null,
  } | null,
};

export type OnUpdateVideoStreamingErrorSubscriptionVariables = {
  cameraID?: string | null,
  vin: string,
};

export type OnUpdateVideoStreamingErrorSubscription = {
  onUpdateVideoStreamingError?:  {
    __typename?: "VideoStreamingError",
    cameraID?: string | null,
    errorCode: VideoStreamingErrorCode,
    errorMessage?: string | null,
    vin: string,
  } | null,
};

export type OnUpdateMissionV2SubscriptionVariables = {
  id: string,
};

export type OnUpdateMissionV2Subscription = {
  onUpdateMissionV2?:  {
    __typename?: "MissionV2",
    id: string,
    vin: string,
    timestamp: string,
    version: string,
    actualArrivalTime?: string | null,
    actualStartTime?: string | null,
    description?: string | null,
    events?:  Array< {
      __typename?: "MissionEvent",
      createdAt: string,
      position:  {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      },
      type: MissionEventType,
    } > | null,
    fleetId: string,
    name: string,
    plannedArrivalTime?: string | null,
    progressDetails?:  {
      __typename?: "MissionProgressDetailsFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "MissionProgressDetailsValueV2",
        eta: string,
        remainingDistanceInMeters: number,
        traveledDistanceInMeters: number,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    route?:  {
      __typename?: "GeneratedRouteV2",
      createdAt: string,
      durationInSeconds: number,
      externalRouteId: string,
      landingHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      launchHub:  {
        __typename?: "Hub",
        active: boolean,
        address?: string | null,
        createdAt: string,
        id: string,
        name: string,
        position:  {
          __typename?: "Coordinate",
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      },
      predefinedRouteId: string,
      totalDistanceInMeters: number,
      updatedAt: string,
      positions:  Array< {
        __typename?: "Position",
        altitude?: number | null,
        heading?: number | null,
        latitude?: number | null,
        longitude?: number | null,
      } >,
    } | null,
    state?:  {
      __typename?: "MissionStateFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "MissionStateValueV2",
        state: MissionStateValue,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateVehicleV2SubscriptionVariables = {
};

export type OnUpdateVehicleV2Subscription = {
  onUpdateVehicleV2?:  {
    __typename?: "VehicleV2",
    vin: string,
    timestamp: string,
    activeMissionId?:  {
      __typename?: "StringFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "StringValueV2",
        data: string,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    adsState?:  {
      __typename?: "AdsStateFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "AdsStateValueV2",
        state: AdsState,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    connectivityStatus?:  {
      __typename?: "ConnectivityStatusFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "ConnectivityStatusValueV2",
        expectDisconnection: boolean,
        latency?: number | null,
        state?: ConnectivityState | null,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    deviations?:  Array< {
      __typename?: "DeviationsFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "DeviationsValueV2",
        deviation:  {
          __typename?: "Deviation",
          category: string,
          description: string,
          id: string,
          isBlocking: boolean,
          origin: string,
          sentAt: string,
          severity: Severity,
          relatedDeviations: Array< string | null >,
          resolvedAt?: string | null,
          state?: DeviationState | null,
        },
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null > | null,
    driverMode?:  {
      __typename?: "DriverModeFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "DriverModeValueV2",
        mode: DriverMode,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    drivingState?:  {
      __typename?: "DrivingStateFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "DrivingStateValueV2",
        state: DrivingState,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    fleetId?: string | null,
    latestVehicleUpdate?: string | null,
    licensePlate?: string | null,
    mrmState?:  {
      __typename?: "MrmStateFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "MrmStateValueV2",
        data:  {
          __typename?: "MrmStateValueDataV2",
          value: MRMStateValue,
          executionPhase?: MrmExecutionPhase | null,
          causes?: Array< string | null > | null,
          startedAt?: string | null,
          triggerBy?: MrmTriggerValue | null,
          mrmType?: MrmType | null,
        },
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    name: string,
    owners:  Array< {
      __typename?: "Owner",
      email: string,
      fullName: string,
      id: string,
      phoneNumber: string,
      position: string,
    } >,
    position?:  {
      __typename?: "PositionFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "PositionValueV2",
        position:  {
          __typename?: "Position",
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    speedMs?:  {
      __typename?: "SpeedMsFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "SpeedMsValueV2",
        speedMs: number,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateVehicleByVINV2SubscriptionVariables = {
  vin: string,
};

export type OnUpdateVehicleByVINV2Subscription = {
  onUpdateVehicleByVINV2?:  {
    __typename?: "VehicleV2",
    vin: string,
    timestamp: string,
    activeMissionId?:  {
      __typename?: "StringFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "StringValueV2",
        data: string,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    adsState?:  {
      __typename?: "AdsStateFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "AdsStateValueV2",
        state: AdsState,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    connectivityStatus?:  {
      __typename?: "ConnectivityStatusFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "ConnectivityStatusValueV2",
        expectDisconnection: boolean,
        latency?: number | null,
        state?: ConnectivityState | null,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    deviations?:  Array< {
      __typename?: "DeviationsFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "DeviationsValueV2",
        deviation:  {
          __typename?: "Deviation",
          category: string,
          description: string,
          id: string,
          isBlocking: boolean,
          origin: string,
          sentAt: string,
          severity: Severity,
          relatedDeviations: Array< string | null >,
          resolvedAt?: string | null,
          state?: DeviationState | null,
        },
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null > | null,
    driverMode?:  {
      __typename?: "DriverModeFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "DriverModeValueV2",
        mode: DriverMode,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    drivingState?:  {
      __typename?: "DrivingStateFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "DrivingStateValueV2",
        state: DrivingState,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    fleetId?: string | null,
    latestVehicleUpdate?: string | null,
    licensePlate?: string | null,
    mrmState?:  {
      __typename?: "MrmStateFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "MrmStateValueV2",
        data:  {
          __typename?: "MrmStateValueDataV2",
          value: MRMStateValue,
          executionPhase?: MrmExecutionPhase | null,
          causes?: Array< string | null > | null,
          startedAt?: string | null,
          triggerBy?: MrmTriggerValue | null,
          mrmType?: MrmType | null,
        },
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    name: string,
    owners:  Array< {
      __typename?: "Owner",
      email: string,
      fullName: string,
      id: string,
      phoneNumber: string,
      position: string,
    } >,
    position?:  {
      __typename?: "PositionFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "PositionValueV2",
        position:  {
          __typename?: "Position",
          altitude?: number | null,
          heading?: number | null,
          latitude?: number | null,
          longitude?: number | null,
        },
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
    speedMs?:  {
      __typename?: "SpeedMsFieldV2",
      ttl?: number | null,
      value?:  {
        __typename?: "SpeedMsValueV2",
        speedMs: number,
        updatedAt: string,
      } | null,
      error?:  {
        __typename?: "ErrorV2",
        type: ErrorTypeV2,
        raisedAt: string,
      } | null,
    } | null,
  } | null,
};

export type OnUpdateActiveMissionByVinSubscriptionVariables = {
  vin: string,
};

export type OnUpdateActiveMissionByVinSubscription = {
  onUpdateActiveMissionByVin?:  {
    __typename?: "MissionUpdateV3",
    vin: string,
    fleetId?: string | null,
    payload: ( {
        __typename?: "MissionV2",
        id: string,
        vin: string,
        timestamp: string,
        version: string,
        actualArrivalTime?: string | null,
        actualStartTime?: string | null,
        description?: string | null,
        events?:  Array< {
          __typename?: string,
          createdAt: string,
          position:  {
            __typename?: string,
            altitude?: number | null,
            heading?: number | null,
            latitude?: number | null,
            longitude?: number | null,
          },
          type: MissionEventType,
        } > | null,
        fleetId: string,
        name: string,
        plannedArrivalTime?: string | null,
        progressDetails?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            eta: string,
            remainingDistanceInMeters: number,
            traveledDistanceInMeters: number,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
        route?:  {
          __typename?: string,
          createdAt: string,
          durationInSeconds: number,
          externalRouteId: string,
          landingHub:  {
            __typename?: string,
            active: boolean,
            address?: string | null,
            createdAt: string,
            id: string,
            name: string,
            position:  {
              __typename?: string,
              latitude?: number | null,
              longitude?: number | null,
            },
            updatedAt: string,
          },
          launchHub:  {
            __typename?: string,
            active: boolean,
            address?: string | null,
            createdAt: string,
            id: string,
            name: string,
            position:  {
              __typename?: string,
              latitude?: number | null,
              longitude?: number | null,
            },
            updatedAt: string,
          },
          predefinedRouteId: string,
          totalDistanceInMeters: number,
          updatedAt: string,
          positions:  Array< {
            __typename?: string,
            altitude?: number | null,
            heading?: number | null,
            latitude?: number | null,
            longitude?: number | null,
          } >,
        } | null,
        state?:  {
          __typename?: string,
          ttl?: number | null,
          value?:  {
            __typename?: string,
            state: MissionStateValue,
            updatedAt: string,
          } | null,
          error?:  {
            __typename?: string,
            type: ErrorTypeV2,
            raisedAt: string,
          } | null,
        } | null,
      } | {
        __typename?: "MissionUnassigned",
        vin: string,
        timestamp: string,
        version: string,
        fleetId: string,
      }
    ),
  } | null,
};
